// src/hooks/useGetSinisterDetails.ts
import { useCallback, useMemo, useState } from "react";
import { ISinisterList, SinisterService } from "../../../shared/services/api/sinister/SinisterService";

// Correto e funcional
export function useGetSinisterDetails(id: string) {
	const [data, setData] = useState<ISinisterList | null>(null);
	const [isLoading, setIsLoading] = useState(false);
	const [error, setError] = useState<Error | null>(null);

	const fetchDetails = useCallback(async () => {
		if (!id || id === "novo") return;

		setIsLoading(true);
		setError(null);

		try {
			const result = await SinisterService.getById(id);
			if (result instanceof Error) throw result;
			setData(result);
		} catch (err: any) {
			setError(err);
			setData(null);
		} finally {
			setIsLoading(false);
		}
	}, [id]);
	
	return {
		data,
		isLoading,
		error,
		refetch: fetchDetails,
	};
}
